export const WhyWeSpecialize = () => {
  const reasons = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Complex Property Expertise',
      description: 'We understand the unique challenges and opportunities of mixed-use properties, from zoning to tenant mix optimization.'
    },
    {
      icon: 'ri-funds-line',
      title: 'Strong Capital Base',
      description: 'Mixed-use properties require significant capital. We have the financial resources to close quickly on larger, more complex deals.'
    },
    {
      icon: 'ri-team-line',
      title: 'Experienced Team',
      description: 'Our team has extensive experience with both residential and commercial real estate, essential for mixed-use success.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Market Knowledge',
      description: 'We understand urban market dynamics, retail trends, and residential demand patterns in mixed-use environments.'
    },
    {
      icon: 'ri-building-line',
      title: 'Operational Capability',
      description: 'We can manage the complexity of multiple tenant types, varied lease structures, and diverse property needs.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Fair Valuations',
      description: 'We provide sophisticated valuations that properly account for both residential and commercial income streams.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Why We Specialize in Mixed-Use Properties
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Mixed-use properties require specialized knowledge, significant capital, and operational expertise across multiple property types. We've built our business to excel in this complex sector.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 text-white rounded-xl mb-6">
                <i className={`${reason.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-900">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">Our Mixed-Use Focus</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                We actively seek mixed-use properties in urban and suburban markets. Whether your property is fully leased or facing vacancy challenges, we're interested in discussing an acquisition.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Any Configuration:</strong> Retail/residential, office/residential, or multi-use</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Any Occupancy:</strong> Fully leased, partially vacant, or repositioning needed</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Any Market:</strong> Downtown, main street, or transit-oriented locations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Any Situation:</strong> Stabilized assets or value-add opportunities</span>
                </li>
              </ul>
            </div>
            <div className="relative">
              <div className="aspect-[4/3] rounded-xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/7a2be94b13e992aa598d2b9bd07d1f4e.jpg"
                  alt="Mixed-Use Expertise"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};